import styled from "styled-components";

const ProductSettingsCard = styled.div`
  background-color: #ffffff;
  padding: 15px 20px;
  margin-bottom: 15px;
  border-radius: 5px;
  border: 1px solid #898d8f;
`;

export default ProductSettingsCard;
